import React, { useEffect, useState } from "react";
import about from "../../assets/about.png";
import about_1 from "../../assets/about-1.jpg";
import about_2 from "../../assets/about-2.jpg";
import about_3 from "../../assets/about-3.webp";
import icon from "../../assets/icon.png";
import { Buttons } from "../Buttons";
import { abouts } from "../../Data/data";

const aboutImages =[about, about_1,about_2,about_3]
const About = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % aboutImages.length);
      }, 4000); // change every 4 seconds
      return () => clearInterval(interval);
    }, []);
  return (
    <div className="w-full h-full bg-black px-[8rem] py-[5rem] md:flex justify-center items-cetner gap-[2rem] flex-wrap">
      <div className="flex-1 flex items-start justify-center gap-[1rem] flex-col">
        <div className="flex gap-[5px] ">
          <img
            src={icon}
            alt=""
            className="w-[24px]  h-[24px] object-contain"
          />
          <p className="text-[18px] font-Quicksand text-white">
            Experienced Property Management Built on Knowledge, Integrity, and
            Results
          </p>
        </div>
        <h1 className="text-[55px] leading-tight font-bold  text-gradient ">
          About Our Company
        </h1>
        <p className="text-[18px] font-light text-white">
          With over 20 years of hands-on experience in real estate and property
          management, we proudly serve residential and commercial property
          owners throughout San Francisco and the greater Bay Area. Our firm was
          built on a simple principle — deliver professional, transparent, and
          results-driven management services that protect and grow our clients’
          investments.
        </p>
        <p className="text-[18px] font-light text-white">
            Our management team includes a licensed Real Estate Broker and Certified Housing Professionals who possess deep knowledge of California property regulations, tenant laws, market trends, and investment strategy. In a region as dynamic and highly regulated as the Bay Area, experience and compliance are not optional — they are essential. We ensure every property under our management operates efficiently, legally, and profitably.
        </p>
        <p className="text-[18px] font-light text-white">
          We manage a diverse portfolio that includes residential homes, multi-unit properties, commercial buildings, and shopping centers. From tenant acquisition and screening to lease administration, rent collection, maintenance coordination, financial reporting, and regulatory compliance, we provide comprehensive oversight designed to reduce vacancies, minimize risk, and optimize long-term returns.
        </p>
        <p className="text-[18px] font-light text-white">
         Our mission is not just to manage properties — it is to provide peace of mind while building lasting partnerships across the San Francisco and Bay Area community.
        </p>
        <Buttons title="Learn More" to="/about" />
      </div>
      <div className="flex-1 flex flex-col gap-[2rem]">
  <div className="relative w-full sm:h-[82%] h-[500px] mt-[2rem]"> {/* give height */}
    {aboutImages.map((img, index) => (
      <img
        key={index}
        src={img}
        alt="Hero"
        className={`
          absolute top-0 left-0 w-full h-full object-cover
          transition-opacity duration-1000 rounded-lg
          ${index === currentIndex ? "opacity-100 z-10" : "opacity-0 z-0"}
        `}
      />
    ))}
  </div>

  <div className="z-50 flex flex-wrap gap-[1rem] justify-center items-center"> {/* fixed typo */}
    {abouts.map((data,index)=>(
      <div
        key={index}
        className="flex-1 bg-[#1A1A1A] transition-all duration-300 ease-in-out hover:bg-[#101010] flex justify-center items-start flex-col gap-[0.2rem] px-[1rem] py-[2rem] rounded-md border border-[#262626]"
      >
        <h1 className="text-gradient text-[40px] font-bold">{data.number}</h1>
        <p className="text-white text-[18px]">{data.title}</p>
      </div>
    ))}
  </div>
</div>
    </div>
  );
};

export default About;
